import { SupportItemCategory, SupportItemFiveArea, AchievementPeriod } from '@/types/supportPlan';

export const categories = [
  { value: 'personal_support', label: '本人支援' },
  { value: 'family_support', label: '家族支援' },
  { value: 'transition_support', label: '移行支援' },
  { value: 'community_collaboration_support', label: '地域支援・地域連携' },
];

export const supportAreaCategories = [
  { value: 'health_life', label: '健康・生活' },
  { value: 'movement_sensory', label: '運動・感覚' },
  { value: 'cognitive_behavioral', label: '認知・行動' },
  { value: 'language_communication', label: '言語・コミュニケーション' },
  { value: 'social_relationships', label: '人間関係・社会性' },
];

export const achievementPeriods = [
  { value: 'three_months', label: '3ヶ月後' },
  { value: 'six_months', label: '6ヶ月後' },
  { value: 'one_year', label: '1年後' },
];

export const priorities = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
];

export const validCategoryValues: SupportItemCategory[] = [
  'personal_support',
  'family_support',
  'transition_support',
  'community_collaboration_support',
];

export const validFiveAreaValues: SupportItemFiveArea[] = [
  'health_life',
  'movement_sensory',
  'cognitive_behavioral',
  'language_communication',
  'social_relationships',
];

export const validAchievementPeriodValues: AchievementPeriod[] = [
  'three_months',
  'six_months',
  'one_year',
];

export const calculateTimeDuration = (startTime: string, endTime: string): string => {
  if (!startTime || !endTime) return '';

  try {
    const start = new Date(`2000-01-01T${startTime}`);
    const end = new Date(`2000-01-01T${endTime}`);

    if (end <= start) return '';

    const diffMs = end.getTime() - start.getTime();
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    return `${hours}時間${minutes.toString().padStart(2, '0')}分`;
  } catch (error) {
    return '';
  }
};

export const calculateTimeMinutes = (startTime: string, endTime: string): number => {
  if (!startTime || !endTime) return 0;

  try {
    const start = new Date(`2000-01-01T${startTime}`);
    const end = new Date(`2000-01-01T${endTime}`);

    if (end <= start) return 0;

    const diffMs = end.getTime() - start.getTime();
    return Math.floor(diffMs / (1000 * 60)); // 分単位で返す
  } catch (error) {
    return 0;
  }
};

export const formatMinutesToDuration = (totalMinutes: number): string => {
  if (totalMinutes === 0) return '';

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${hours}時間${minutes.toString().padStart(2, '0')}分`;
};
